module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Clipboard-f3c0bb37082dcafa1bb6b8065e37d09e.svg";